const translations = {
  // Navigation
  "nav.successStories": "Success Stories",
  "nav.startups": "Startups",
  "nav.innovations": "Innovations",
  "nav.femmes": "Women",
  "nav.diaspora": "Diaspora",
  "nav.more": "More",
  "nav.jeunesTalents": "Young Talents",
  "nav.interviews": "Exclusive Interviews",
  "nav.opportunites": "Opportunities",
  "nav.formations": "Training",
  "nav.apropos": "About",
  "nav.search": "Search",
  "nav.searchGlobal": "Global search",
  "nav.searchPlaceholder": "Search a story, entrepreneur, country...",
  "nav.popular": "Popular:",

  // Hero
  "hero.tagline": "The media that inspires entrepreneurship in Africa",
  "hero.taglineMobile": "Wazi Stories Africa",
  "hero.headline1": "Africa",
  "hero.headline2": "winning.",
  "hero.subtitle": "500+ success stories, exclusive interviews, funding opportunities and training for African entrepreneurs — all in one place.",
  "hero.cta.explore": "Explore stories",
  "hero.cta.interviews": "Watch interviews",
  "hero.quickLinks.interviews.label": "Interviews",
  "hero.quickLinks.interviews.sublabel": "Exclusive",
  "hero.quickLinks.interviews.badge": "LIVE",
  "hero.quickLinks.opportunites.label": "Opportunities",
  "hero.quickLinks.opportunites.sublabel": "Jobs & Funding",
  "hero.quickLinks.opportunites.badge": "New",
  "hero.quickLinks.formations.label": "Training",
  "hero.quickLinks.formations.sublabel": "Salesforce · Odoo",
  "hero.quickLinks.formations.badge": "Wazi",
  "hero.featured.label": "Story of the moment",
  "hero.featured.read": "Read",
  "hero.stats.stories": "Success Stories",
  "hero.stats.interviews": "Video interviews",
  "hero.stats.opportunites": "Active opportunities",
  "hero.stats.formations": "Training programs",
  "hero.stats.pays": "African countries",
  "hero.stats.lecteurs": "Monthly readers",

  // Categories
  "categories.title": "Explore by Theme",
  "categories.subtitle": "Dive into the stories that inspire you",
  "categories.articles": "articles",
  "categories.newRubriques": "New sections",
  "categories.tagline": "The media that inspires entrepreneurship",
  "categories.interviews.desc": "Top entrepreneurs open up",
  "categories.opportunites.desc": "Jobs, funding & calls for projects",
  "categories.formations.desc": "Salesforce, Odoo & exclusive bootcamp",
  "categories.interviews.badge": "LIVE",
  "categories.opportunites.badge": "New",
  "categories.formations.badge": "Wazi Partner",

  // Trending
  "trending.title": "Top Stories",
  "trending.subtitle": "The stories making African entrepreneurship news",
  "trending.recent": "Most recent",
  "trending.popular": "Most read",
  "trending.viewAll": "View all articles",
  "trending.recent.badge": "Recent",

  // Sections
  "section.successStories.title": "Success Stories",
  "section.successStories.subtitle": "Extraordinary journeys proving anything is possible",
  "section.startups.title": "African Startups",
  "section.startups.subtitle": "The companies shaping the future of the continent",
  "section.femmes.title": "Women Entrepreneurs",
  "section.femmes.subtitle": "They are building tomorrow's Africa with boldness and determination",
  "section.innovations.title": "Innovations & Inventions",
  "section.innovations.subtitle": "Africa invents tomorrow's solutions",
  "section.jeunesTalents.title": "Young Talents",
  "section.jeunesTalents.subtitle": "The new generation reinventing Africa",
  "section.diaspora.title": "African Diaspora",
  "section.diaspora.subtitle": "They carry Africa in their hearts and projects",
  "section.interviews.title": "Exclusive Interviews",
  "section.interviews.subtitle": "Top African entrepreneurs open up",
  "section.opportunites.title": "Opportunities",
  "section.opportunites.subtitle": "Jobs, funding and calls for projects for African entrepreneurs",
  "section.formations.title": "Training",
  "section.formations.subtitle": "Develop your skills with our certified partners",
  "section.viewAll": "View all",
  "section.discover": "Discover",
  "section.read": "Read",

  // Article
  "article.readTime": "min read",
  "article.views": "views",
  "article.source": "Original article",
  "article.sourceDesc": "This content is an editorial summary. To read the full story, visit the original source on",
  "article.readFull": "Read the full article on",
  "article.share": "Share this story:",
  "article.related": "Related articles",
  "article.notFound": "Article not found",
  "article.backHome": "Back to home",
  "article.fullAnalysis": "Full analysis",

  // Listing
  "listing.results": "story found",
  "listing.results_plural": "stories found",
  "listing.noResults": "No results found",
  "listing.noResultsHint": "Try different filters or keywords",
  "listing.searchPlaceholder": "Search by name, entrepreneur...",
  "listing.allCountries": "All countries",
  "listing.allSectors": "All sectors",
  "listing.reset": "Reset",
  "listing.showFilters": "Show filters",
  "listing.hideFilters": "Hide",
  "listing.activeFilters": "Active filters",
  "listing.filterHint": "Filter by country / sector",

  // Listing page configs
  "listing.successStories.title": "Success Stories",
  "listing.successStories.subtitle": "Extraordinary journeys proving anything is possible in Africa",
  "listing.startups.title": "African Startups",
  "listing.startups.subtitle": "Innovative companies shaping the future of the African continent",
  "listing.innovations.title": "Innovations & Inventions",
  "listing.innovations.subtitle": "Africa invents tomorrow's solutions for the entire world",
  "listing.femmes.title": "Women Entrepreneurs",
  "listing.femmes.subtitle": "They are building tomorrow's Africa with boldness and determination",
  "listing.jeunesTalents.title": "Young Talents",
  "listing.jeunesTalents.subtitle": "The new generation reinventing Africa with creativity",
  "listing.diaspora.title": "African Diaspora",
  "listing.diaspora.subtitle": "They left the continent but carry Africa in their hearts and projects",

  // Submit & Newsletter
  "submit.badge": "Your story matters",
  "submit.title": "Do you have an inspiring story to share?",
  "submit.subtitle": "Submit your entrepreneurial journey and inspire thousands of young Africans. Every story counts, every success deserves to be celebrated.",
  "submit.cta": "Submit my story",
  "submit.stat.readers": "Monthly readers",
  "submit.stat.shares": "WhatsApp shares",
  "submit.stat.countries": "Countries reached",
  "newsletter.title": "Stay Inspired every week",
  "newsletter.subtitle": "Receive the best African success stories directly in your inbox. Free, no spam.",
  "newsletter.placeholder": "Your email address",
  "newsletter.cta": "Subscribe",
  "newsletter.success": "Thank you! You will receive the best stories every week.",
  "newsletter.error": "An error occurred. Please try again.",
  "newsletter.legal": "By subscribing, you agree to receive our weekly newsletter. Unsubscribe at any time.",

  // Footer
  "footer.tagline": "The media that inspires entrepreneurship in Africa",
  "footer.desc": "Success stories, exclusive interviews, opportunities and training for African entrepreneurs.",
  "footer.explore": "Explore",
  "footer.resources": "Resources",
  "footer.contact": "Contact",
  "footer.partners": "Training partners",
  "footer.copyright": "© 2026 Wazi Stories Africa. All rights reserved.",
  "footer.motto": "The media that inspires entrepreneurship in Africa",
  "footer.links.successStories": "Success Stories",
  "footer.links.startups": "African Startups",
  "footer.links.innovations": "Innovations & Inventions",
  "footer.links.femmes": "Women Entrepreneurs",
  "footer.links.jeunesTalents": "Young Talents",
  "footer.links.diaspora": "African Diaspora",
  "footer.links.interviews": "Exclusive Interviews",
  "footer.links.opportunites": "Opportunities",
  "footer.links.formations": "Training",
  "footer.links.recherche": "Global search",
  "footer.links.soumettre": "Submit a story",
  "footer.links.apropos": "About",

  // Startup card
  "startup.discover": "Discover",
  "startup.source": "Source:",

  // Femme card
  "femme.read": "Read",

  // Search page
  "search.title": "Search",
  "search.placeholder": "Search a story, entrepreneur, country...",
  "search.results": "result for",
  "search.results_plural": "results for",
  "search.noResults": "No results for",
  "search.noResultsHint": "Try different keywords",
  "search.allCategories": "All categories",

  // Soumettre page
  "soumettre.title": "Submit a story",
  "soumettre.subtitle": "Share your entrepreneurial journey with our community",

  // Opportunites
  "opportunites.title": "Opportunities",
  "opportunites.subtitle": "Jobs, funding and calls for projects for African entrepreneurs",

  // Formations
  "formations.title": "Training",
  "formations.subtitle": "Develop your skills with our certified partners",

  // Interviews
  "interviews.title": "Exclusive Interviews",
  "interviews.subtitle": "Top African entrepreneurs open up",

  // A propos
  "apropos.title": "About Wazi Stories",

  // Language switcher
  "lang.fr": "Français",
  "lang.en": "English",

  // SectionHeader
  "section.viewAll.label": "View all",

  // Interviews section
  "interviews.exclusive.badge": "Exclusive",
  "interviews.subtitle.wazi": "Top African entrepreneurs open up to Wazi Stories",
  "interviews.viewAll": "All interviews",
  "interviews.viewAllFull": "View all interviews",
  "interviews.views": "views",

  // Opportunites section
  "opportunites.filter.all": "All",
  "opportunites.filter.funding": "Funding",
  "opportunites.filter.job": "Jobs",
  "opportunites.filter.appel": "Calls for projects",
  "opportunites.type.job": "Job",
  "opportunites.type.funding": "Funding",
  "opportunites.type.appel": "Call for projects",
  "opportunites.remote": "Remote",
  "opportunites.viewAll": "View all opportunities",

  // Formations section
  "formations.partner.title": "Wazi Partnerships — Certified training",
  "formations.partner.desc": "Salesforce, Odoo and our exclusive bootcamp available with Wazi support",
  "formations.partner.cta": "Discover training",
  "formations.certified": "Certified",
  "formations.register": "Enroll",
  "formations.level.beginner": "Beginner",
  "formations.level.intermediate": "Intermediate",
  "formations.level.advanced": "Advanced",

  // Diaspora section
  "diaspora.alsoIn": "Also in the diaspora...",
  "diaspora.cta.title": "Are you part of the diaspora?",
  "diaspora.cta.desc": "Share your journey and inspire the next generation of African entrepreneurs.",
  "diaspora.cta.btn": "Submit my story",
  "diaspora.world": "World",

  // ArticleKeyPoints
  "keypoints.impact": "Impact in numbers",
  "keypoints.keypoints": "Key takeaways",
  "keypoints.quote": "Quote",

  // ArticleCard
  "card.share.whatsapp": "Share on WhatsApp",
  "card.share.linkedin": "Share on LinkedIn",

  // MobileBottomNav
  "mobile.home": "Home",
  "mobile.stories": "Stories",
  "mobile.search": "Search",
  "mobile.opportunites": "Opportunities",
  "mobile.more": "More",

  // Interviews page
  "interviews.page.title": "Exclusive Interviews — African Entrepreneurs | Wazi Stories Africa",
  "interviews.page.desc": "Deep conversations with Africa's greatest entrepreneurs. Unfiltered, straight talk.",
  "interviews.hero.badge": "Exclusive",
  "interviews.hero.subtitle": "Africa's top entrepreneurs open up to Wazi Stories. Deep conversations, no filter.",
  "interviews.stats.total": "Interviews",
  "interviews.stats.views": "Total views",
  "interviews.stats.countries": "Represented",
  "interviews.featured.label": "Interview of the moment",
  "interviews.all.label": "All interviews",
  "interviews.meta.views": "views",

  // Opportunites page
  "opportunites.page.title": "Opportunities — Jobs, Funding & Calls for Projects | Wazi Stories",
  "opportunites.page.desc": "The best opportunities for African entrepreneurs and professionals, updated every week.",
  "opportunites.hero.title": "Jobs, Funding & Calls for Projects",
  "opportunites.hero.subtitle": "The best opportunities for African entrepreneurs and professionals, updated every week.",
  "opportunites.filter.all.icon": "All",
  "opportunites.results": "opportunity available",
  "opportunites.results_plural": "opportunities available",
  "opportunites.noResults": "No opportunities found",
  "opportunites.search.placeholder": "Search an opportunity, organization, sector...",
  "opportunites.cta.title": "Do you have an opportunity to share?",
  "opportunites.cta.desc": "Post your job offer, call for projects or funding program for free on Wazi.",
  "opportunites.cta.btn": "Submit an opportunity",
  "opportunites.stats.funding": "Funding",
  "opportunites.stats.jobs": "Jobs",
  "opportunites.stats.appels": "Calls",

  // Formations page
  "formations.page.title": "Training — Salesforce, Odoo & Wazi Bootcamp | Wazi Stories",
  "formations.page.desc": "The best certified training for African entrepreneurs: Salesforce, Odoo, Google, Microsoft and the exclusive Wazi bootcamp.",
  "formations.hero.badge": "Certified training",
  "formations.hero.title": "Level up your skills",
  "formations.hero.subtitle": "Salesforce, Odoo, Google, Microsoft and the exclusive Wazi bootcamp — the best training for African entrepreneurs.",
  "formations.wazi.title": "Wazi Stories Partnerships",
  "formations.wazi.desc": "Salesforce Trailhead, Odoo Learning and our exclusive bootcamp with personalized support",
  "formations.wazi.cta": "View Wazi training",
  "formations.search.placeholder": "Search for training...",
  "formations.filter.allLevels": "All levels",
  "formations.filter.allFormats": "All formats",
  "formations.filter.online": "Online",
  "formations.filter.inPerson": "In-person",
  "formations.filter.hybrid": "Hybrid",
  "formations.filter.wazi": "Wazi Partner",
  "formations.filter.toggle": "Filters",
  "formations.filter.hide": "Hide",
  "formations.filter.reset": "Reset",
  "formations.filter.active": "active filter",
  "formations.filter.active_plural": "active filters",
  "formations.filter.hint": "Filter training",
  "formations.results": "training available",
  "formations.results_plural": "training programs available",
  "formations.noResults": "No training found",
  "formations.cta.title": "Do you offer training?",
  "formations.cta.desc": "Join the Wazi ecosystem and reach thousands of African entrepreneurs.",
  "formations.cta.btn": "Submit training",

  // À propos page
  "apropos.hero.badge": "Our story",
  "apropos.hero.headline": "We tell the story of Africa winning",
  "apropos.hero.subtitle": "Wazi Stories Africa was born from a simple conviction: Africa is full of talents, innovators and extraordinary entrepreneurs who deserve to be celebrated.",
  "apropos.mission.title": "Our mission",
  "apropos.mission.p1": "Wazi Stories Africa is the digital reference for African success stories. We aggregate, highlight and promote positive content about African entrepreneurship — success stories, innovations, promising startups and inspiring journeys.",
  "apropos.mission.p2": "Our goal is simple: inspire African youth, promote local talent and connect opportunities across the continent. Because every African success story deserves to be told and shared.",
  "apropos.mission.cta.stories": "Discover stories",
  "apropos.mission.cta.submit": "Submit a story",
  "apropos.mission.badge.stories": "Success stories published",
  "apropos.mission.badge.countries": "African countries represented",
  "apropos.stats.title": "Wazi Stories by the numbers",
  "apropos.stats.subtitle": "A platform growing with Africa",
  "apropos.stats.stories": "Success stories published",
  "apropos.stats.countries": "African countries represented",
  "apropos.stats.readers": "Monthly readers",
  "apropos.stats.shares": "WhatsApp shares / month",
  "apropos.stats.innovations": "Documented innovations",
  "apropos.stats.women": "Women entrepreneur stories",
  "apropos.values.title": "Our values",
  "apropos.values.subtitle": "These principles guide every editorial decision and every story we choose to tell",
  "apropos.values.positivity.title": "Positivity",
  "apropos.values.positivity.desc": "We only tell inspiring and constructive stories. Africa needs narratives that elevate, not diminish.",
  "apropos.values.authenticity.title": "Authenticity",
  "apropos.values.authenticity.desc": "Every story is verified and sourced. We always cite the origin of articles and redirect to original sources.",
  "apropos.values.inclusion.title": "Inclusion",
  "apropos.values.inclusion.desc": "We value all forms of entrepreneurship: tech startups, local SMEs, crafts, agriculture, diaspora, women, youth.",
  "apropos.values.panafrican.title": "Pan-Africanism",
  "apropos.values.panafrican.desc": "We cover all 54 African countries without distinction. Every corner of the continent has heroes who deserve to be known.",
  "apropos.values.innovation.title": "Innovation",
  "apropos.values.innovation.desc": "We highlight African solutions to African problems. Africa invents, creates and innovates every day.",
  "apropos.values.community.title": "Community",
  "apropos.values.community.desc": "We build a space where entrepreneurs, investors and readers connect, inspire and support each other.",
  "apropos.team.title": "The team",
  "apropos.team.subtitle": "A passionate pan-African team, spread across the continent, united by a shared conviction",
  "apropos.team.join.title": "Join the team",
  "apropos.team.join.desc": "Are you a journalist, developer, designer or passionate about African entrepreneurship? We are recruiting correspondents across Africa.",
  "apropos.team.join.cta": "Contact us",
  "apropos.timeline.title": "Our journey",
  "apropos.timeline.subtitle": "From idea to African reference",
  "apropos.partners.title": "Our partners",
  "apropos.partners.subtitle": "Together to promote African entrepreneurship",
  "apropos.partners.cta.text": "Would you like to become a partner of Wazi Stories Africa?",
  "apropos.partners.cta.btn": "Become a partner",
  "apropos.partners.media": "Media partner",
  "apropos.partners.investment": "Investment partner",
  "apropos.partners.network": "Incubator network",
  "apropos.cta.title": "Join the movement",
  "apropos.cta.subtitle": "Do you have a story to share? Do you know an inspiring African entrepreneur? Help build the largest library of African success stories.",
  "apropos.cta.submit": "Submit a story",
  "apropos.cta.newsletter": "Subscribe to newsletter",

  // Soumettre page
  "soumettre.hero.title": "Submit your story",
  "soumettre.hero.subtitle": "Share your entrepreneurial journey and inspire thousands of young Africans.",
  "soumettre.success.title": "Story submitted successfully!",
  "soumettre.success.desc": "Our team will review your story and contact you within 48 hours.",
  "soumettre.form.name": "Your full name *",
  "soumettre.form.name.placeholder": "Ex: Aminata Koné",
  "soumettre.form.email": "Email *",
  "soumettre.form.country": "Country *",
  "soumettre.form.country.select": "Select a country",
  "soumettre.form.sector": "Industry *",
  "soumettre.form.sector.select": "Select a sector",
  "soumettre.form.company": "Your company / project name *",
  "soumettre.form.company.placeholder": "Ex: AfriPay Solutions",
  "soumettre.form.story": "Your story *",
  "soumettre.form.story.placeholder": "Tell us about your journey, challenges, achievements... (500 characters max)",
  "soumettre.form.link": "Link to your website / social media",
  "soumettre.form.submit": "Submit my story",
  "soumettre.form.error": "An error occurred. Please try again.",

  // Recherche page
  "recherche.title": "Global search",
  "recherche.subtitle.results": "result for",
  "recherche.subtitle.results_plural": "results for",
  "recherche.subtitle.empty": "Explore 500+ stories of African entrepreneurs",
  "recherche.trends": "Trending:",
  "recherche.filters.title": "Filters",
  "recherche.filters.category": "Category",
  "recherche.filters.sector": "Sector",
  "recherche.filters.reset": "Reset filters",
  "recherche.sort.label": "Sort by:",
  "recherche.sort.relevance": "Relevance",
  "recherche.sort.date": "Date",
  "recherche.sort.views": "Popularity",
  "recherche.empty.title": "What are you looking for?",
  "recherche.empty.desc": "Type the name of an entrepreneur, country, sector or African startup.",
  "recherche.noResults.title": "No results",
  "recherche.noResults.desc": "No story found for",
  "recherche.noResults.hint": "Try different keywords.",
  "recherche.results.count": "result",
  "recherche.results.count_plural": "results",
  "recherche.results.for": "for",
  "recherche.read": "Read",
  "recherche.filterToggle": "Filters",
  "recherche.filterHint": "Filter results",

  // GlobalSearchBar
  "search.suggestions": "Suggestions",
  "search.loading": "Searching...",
  "search.seeAll": "See all results for",
  "search.noResult": "No results for",
  "search.searchAnyway": "Search anyway →",
  "search.browseCategory": "Browse by category",
};

export default translations;
